import {
  BillerPlan,
  BillerPlansPayload,
} from "features/bbps/biller/billerFlowTypes";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BillerPlansState {
  loading: boolean;
  plans: BillerPlan[];
  error?: NormalizedError | null;
}

const initialState: BillerPlansState = {
  loading: false,
  plans: [],
  error: null,
};

const billerPlansSlice = createSlice({
  name: "billerPlans",
  initialState,
  reducers: {
    billerPlansRequested(state, _action: PayloadAction<BillerPlansPayload>) {
      state.loading = true;
      state.error = null;
    },
    billerPlansSucceeded(state, action: PayloadAction<BillerPlan[]>) {
      state.loading = false;
      state.plans = action.payload;
      state.error = null;
    },
    billerPlansFailed(state, action: PayloadAction<NormalizedError>) {
      state.loading = false;
      state.error = action.payload;
    },
    billerPlansReset() {
      return initialState;
    },
  },
});

export const {
  billerPlansRequested,
  billerPlansSucceeded,
  billerPlansFailed,
  billerPlansReset,
} = billerPlansSlice.actions;

export default billerPlansSlice.reducer;
